import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { List, X } from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/candidats", label: "Candidats" },
  { to: "/entreprises", label: "Entreprises" },
  { to: "/formulaire", label: "Formulaire" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-navy-deep/95 backdrop-blur-xl border-b border-white/10" : "bg-navy-deep"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" data-testid="header-logo" className="flex items-center group">
          <img
            src="/logo-cropped.png"
            alt="MP Advisory — Cabinet de recrutement Sales & IT"
            className="block h-10 sm:h-12 w-auto rounded-md transition-transform group-hover:scale-105"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10" data-testid="desktop-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `relative text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-white" : "text-white/70 hover:text-white"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  {isActive && (
                    <span className="absolute -bottom-2 left-0 right-0 h-px bg-purple-accent" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        {/* Right side */}
        <div className="flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="header-contact-btn"
            className="hidden md:inline-flex items-center gap-2 rounded-full border border-white/30 hover:border-white hover:bg-white/5 text-white px-5 py-2.5 text-sm font-medium transition-all"
          >
            Nous contacter
          </Link>
          <div className="hidden md:flex items-center justify-center w-10 h-10 rounded-full border border-white/30 text-white text-xs font-medium tracking-wider">
            FR
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setMobileOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 text-white"
            aria-label="Menu"
          >
            {mobileOpen ? <X size={24} /> : <List size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-navy-deep border-t border-white/10" data-testid="mobile-menu">
          <nav className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base font-medium ${isActive ? "text-purple-accent" : "text-white/80"}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-contact-btn"
              className="inline-flex items-center justify-center rounded-full border border-white/30 text-white px-5 py-3 text-sm mt-2"
            >
              Nous contacter
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
